'use client';

import { Input } from '@/components/ui/input';

interface TextInputSectionProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'number';
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export function TextInputSection({
  value,
  onChange,
  placeholder,
  type = 'text',
  disabled = false,
  size = 'md',
}: TextInputSectionProps) {
  return (
    <Input
      type={type}
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      inputSize={size}
      className='w-full'
    />
  );
}
